import { makeEnum } from "./utilities/makeEnum";

export const EventModerationStatusEnum = makeEnum({
    Pending: {
        id: 'pending',
        name: 'На модерации',
        color: 'blue',
        icon: 'loader',
    },
    Agreed: {
        id: 'agreed',
        name: 'Согласовано',
        color: 'green',
        icon: 'check-circle',
    },
    Error: {
        id: 'error',
        name: 'Требует корректировки',
        color: 'red',
        icon: 'alert-circle',
    },
} as const);
